// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks/search-bar-marine/style-view","blocks/weather-summary/style-view","blocks/world-forecast-summary/style-view"], () => (__webpack_require__("./src/blocks/world-forecast-summary/view.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
